import { MDBBtn, MDBModalFooter, MDBSpinner, MDBTextArea } from 'mdb-react-ui-kit';
import React, { forwardRef, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router';
import { addGroupUser } from '../../../apiclients/streamsapi_bridge';

const AddUsersGroups = forwardRef((props, ref) => {
    //const [isloading, setIsloading] = useState(false);
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors, isDirty }, clearErrors, setError, watch, setValue } = useForm({
        defaultValues: {
            name: "",
            description: "",

        }
    });

    const onSubmit = async (data) => {

        if (isDirty) {
            let update = {
                reqid: 75,
                siteid: JSON.parse(
                    sessionStorage.getItem("admin_session")
                ).siteid,
                name: data.name,
                description: data.description,
            };
            console.log("request for add group user :::" + JSON.stringify(update));
            props.setIsloading(true);
            let saverep = await addGroupUser(update);
            console.log(`reponse of phone edit :::: ${JSON.stringify(saverep)}`);
            let saverepeMsg = await saverep.json();
            console.log(
                "response of add group user :::" + JSON.stringify(saverepeMsg)
            );
            setTimeout(() => {
                props.setIsloading(false);
            }, 1000);
            if (saverepeMsg.status && saverepeMsg.status == "success") {
                sessionStorage.setItem("ugroup_updated", true);
                // props.setSuccessMessage(saverepeMsg.message);
                localStorage.setItem("s_message", saverepeMsg.message);
                navigate("/userlanding", {
                    state: { tab: "mgroups" },
                });
                 window.location.reload();
                props.onClose();
            } else {
                if (saverepeMsg.message?.errors) {
                    saverepeMsg.message.errors.forEach((err) => {

                        setError(err.param_name, {
                            type: "server",
                            message: err.message,
                        });
                        const fieldElement = document.querySelector(
                            `input[name="${err.param_name}"]`
                        );
                        if (fieldElement) {
                            fieldElement.focus();
                            fieldElement.scrollIntoView({ behavior: "smooth" });
                        }
                    });
                }
            }
        }



    }
    return (
        <>
            <div>
                <div className="tel-numbers">
                    <strong>{t("name")}</strong>
                    <div className="form pt-1">
                        <input
                            type="text"
                            className="w-100"
                            {...register("name", { required: "Name is required" })}
                        />
                        {errors.name && (
                            <p className="text-danger">{errors.name.message}</p>
                        )}
                    </div>
                </div>
                <div className="tel-numbers mt-1">
                    <strong>{t("Description")}</strong>
                    <div className="form pt-1">
                        <MDBTextArea
                          {...register("description", { required: "Description is required" })}
                            id="textAreaExample"
                            className="w-100"
                            rows={4}
                            value = {watch("description")}
                            onChange={(e) => {
                                clearErrors("description");
                                setValue("description", e.target.value, {shouldDirty: true})
                        }}
                        />
                        {errors.description && (
                            <p className="text-danger">{errors.description.message}</p>
                        )}
                    </div>
                </div>
            </div>

            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => { e.preventDefault(); handleSubmit(onSubmit)() }}>
                    {t("add")}</button>
            </div>

            {/* <MDBModalFooter>
                <MDBBtn color="secondary" onClick={(e) => props.onClose()}>
                    {t("close")}
                </MDBBtn>
                <MDBBtn onClick={(e) => {
                    e.preventDefault();
                    handleSubmit(onSubmit)();
                }}>{t("add")}</MDBBtn>
            </MDBModalFooter> */}
            {/* {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )} */}

        </>
    )
});

export default AddUsersGroups
